var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControllerTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 41.9,
    viewBox: "0 0 42 41.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_401",
    x: 0,
    y: 0.2,
    width: 42,
    height: 41.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_18",
    x: 6,
    y: 0,
    width: 30,
    height: 35.699,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONTROLLER",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_401)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_401-2",
    "data-name": "Pfad 401",
    fill: "#f5f5f5",
    d: "M21.3.2v2a16,16,0,1,1-6.6,0V.2a18,18,0,1,0,6.6,0Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_18)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_18-2",
    "data-name": "Vereinigungsmenge 18",
    className: "cls-1",
    d: "M4404-2793.3a11.824,11.824,0,0,1,7.5-11.1,1.066,1.066,0,0,1,1.4.6,1.067,1.067,0,0,1-.6,1.4,9.8,9.8,0,0,0-6.1,9.1,9.815,9.815,0,0,0,9.8,9.8,9.815,9.815,0,0,0,9.8-9.8,9.855,9.855,0,0,0-6.4-9.2,1.113,1.113,0,0,1-.6-1.4,1.115,1.115,0,0,1,1.4-.6,11.986,11.986,0,0,1,7.8,11.2,12.035,12.035,0,0,1-12,12A12.035,12.035,0,0,1,4404-2793.3Zm9,2.8c0-1.7,3-6,3-6s3,4.3,3,6a3.008,3.008,0,0,1-3,3A3.008,3.008,0,0,1,4413-2790.5Zm3.5-.3a.736.736,0,0,0,.8.8c.5,0,.8-.2.8-.7a.789.789,0,0,0-.8-.8A.709.709,0,0,0,4416.5-2790.8Zm-1.6-9.3V-2811h2.2v10.9a1.109,1.109,0,0,1-1.1,1.1A1.11,1.11,0,0,1,4414.9-2800.1Z",
    transform: "translate(-4395 2814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerTool);
export default __webpack_public_path__ + "static/media/controller-tool.6a44e7d3e8c090ba1a2d7cdf527e7e14.svg";
export { ForwardRef as ReactComponent };